import React from 'react'

export const NoRecords = () => {
    return (
        <>
            <div className={'text-center'}><strong>Zatiaľ neboli pridané žiadne záznamy :(</strong></div>
        </>
    )
}